import React from 'react'
import _ from 'lodash'
import {
  FormInput,
  FormInputDate,
  FormInputText,
  FormInputSelect
} from 'camino-react'
import PropTypes from 'prop-types'
import moment from 'moment'

import ServiceType from 'Components/Tickets/Form/Sections/Services/ServiceType'

const TicketCreateFormSectionsUserManagementFields = ({
  hidden,
  setFieldValue,
  regionMetadata,
  title,
  sub_category_id,
  serviceCategories,
  setNextModalSection,
  serviceCategoryId,
  userManagementCategoryId
}) => {
  if (hidden) {
    return null
  }

  const setValues = (name, value) => {
    const newFields = Object.assign({}, regionMetadata, { [name]: value })

    const description = `${title}
Username: ${regionMetadata.username}
Email Address: ${regionMetadata.email_address}
Requested Completion Date: ${moment(regionMetadata.requested_completion_date).format('YYYY-MM-DD')}`

    setFieldValue('regionMetadata', newFields)
    setFieldValue('description', description)
  }

  const setTitle = (subCategory, usersFirstAndLastName) => {
    if (_.isNil(subCategory) || _.isNil(usersFirstAndLastName)) { return }

    setFieldValue('title', `${subCategory}: ${usersFirstAndLastName}`)
  }

  const userManagementCategory = _.find(serviceCategories, ['name', 'User Management'])

  let requestTypes = [
    { label: 'Add user', value: 'Add user' },
    { label: 'Remove user', value: 'Remove user' },
    { label: 'Disable user', value: 'Disable user' }
  ]

  if (userManagementCategory) {
    requestTypes = _.map(_.filter(
      serviceCategories,
      ['parent_id', userManagementCategory.id]
    ), ({ id, name }) => ({ value: id, label: name }))
  }

  return (
    <div>
      <ServiceType {...{
        serviceCategoryId, setFieldValue, setNextModalSection, userManagementCategoryId
      }}
      />

      <FormInput label="Request Type">
        <FormInputSelect
          options={requestTypes}
          value={_.find(requestTypes, ['value', sub_category_id])}
          onValue={(value) => {
            setTitle(
              _.get(
                _.find(requestTypes, ['value', value])
              ),
              regionMetadata.users_first_and_last_name
            )
            setFieldValue('sub_category_id', value)
          }}
        />
      </FormInput>

      <FormInput label="Users First and Last Name">
        <FormInputText
          value={regionMetadata.users_first_and_last_name}
          onValue={(value) => {
            setTitle(
              _.get(
                _.find(requestTypes, ['value', sub_category_id]),
                'label'
              ),
              value
            )
            setValues('users_first_and_last_name', value)
          }}
        />
      </FormInput>

      <FormInput label="Username">
        <FormInputText
          value={regionMetadata.username}
          onValue={value => setValues('username', value)}
        />
      </FormInput>

      <FormInput label="Email Address">
        <FormInputText
          value={regionMetadata.email_address}
          onValue={value => setValues('email_address', value)}
        />
      </FormInput>

      <FormInput label="Requested Completion Date">
        <FormInputDate
          value={regionMetadata.requested_completion_date}
          onValue={value => setValues('requested_completion_date', value)}
        />
      </FormInput>

      <div className="form-section">
        <div className="form-section__actions">
          <button
            type="button"
            className="button button--outline form-section__action"
            onClick={() => { window.location.reload(true) }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="button form-section__action"
            onClick={() => setNextModalSection('Contacts')}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  )
}

TicketCreateFormSectionsUserManagementFields.defaultProps = {
  hidden: false
}

TicketCreateFormSectionsUserManagementFields.propTypes = {
  hidden: PropTypes.bool,
  setFieldErrorClasses: PropTypes.func.isRequired,
  setNextModalSection: PropTypes.func.isRequired
}

export default TicketCreateFormSectionsUserManagementFields
